import React from 'react'
import PropTypes from 'prop-types'

export const RevenueCell = ({ revenue = '-' }) => <div>{revenue}</div>

RevenueCell.propTypes = {
  revenue: PropTypes.string,
}
